$ = require 'jquery'
Elements = require '../elements'
{ map } = require 'lodash'

module.exports =
class worksSequence

  constructor: ->
    @$window   = Elements.$window
    @$section  = $ '.section-works'
    @$heading  = @$section.find '.heading'
    @$projects = @$section.find '.projects'

    $.easeplus.addBackOut 'workListFirstBackOut', 1

  getInitialVals: =>
    [
      {
        e: [ @$heading, @$projects ]
        p: { display: 'none' }
      }
    ]

  getSequences: =>
    @$frameHr = @$section.find '.frame-top, .frame-bottom'
    @$frameVt = @$section.find '.frame-right, .frame-left'
    @$title   = @$projects.find '.title'

    @$frameHr.add(@$frameVt).add(@$title)
      .css 'display', 'none'

    {
      first: [
        {
          e: @$heading
          p:
            opacity   : [ 1, 0 ]
            translateX: [ 0, 'easeOutSine', -200 ]
          o: { duration: 300, display: 'block' }
        }
        {
          e: @$projects
          p: { translateX: [ 0, 'workListFirstBackOut', @$window.width() ] }
          o: { duration: 500, display: 'block', delay: 300 }
        }
        {
          e: @$title
          p:
            opacity   : [ 1, 0 ]
            translateX: [ 0, 'easeOutSine', -200 ]
          o: { duration: 200, display: 'block' }
        }
        {
          e: @$frameHr
          p: { width: [ '100%', 0 ] }
          o: { duration: 300, easing: 'easeOutCubic', display: 'block', delay: 300 }
        }
        {
          e: @$frameVt
          p: { height: [ '100%', 0 ] }
          o: { duration: 300, easing: 'easeOutCubic', display: 'block', sequenceQueue: false }
        }
      ]
    }



// WEBPACK FOOTER //
// ./webpack/requires/pc/views/anime-sequence/works-sequence.coffee